import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/morentouxiang.png'
import _imports_1 from '@/assets/image/我的订单.png'
import _imports_2 from '@/assets/image/作品管理.png'
import _imports_3 from '@/assets/image/我的账户.png'
import _imports_4 from '@/assets/image/我的收藏.png'
import _imports_5 from '@/assets/image/我的足迹.png'
import _imports_6 from '@/assets/image/使用指南.png'


const _withScopeId = n => (_pushScopeId("data-v-22d54b3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = {
  key: 0,
  class: "Rotation"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "container contents"
}
const _hoisted_5 = { class: "left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "自动化设计方案", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "one-img",
  src: "https://image.sjyuan.net.cn/img/sjy/share/indextz.png"
}, null, -1))
const _hoisted_8 = { class: "second" }
const _hoisted_9 = { class: "onemenu" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "list" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "list" }
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { class: "list" }
const _hoisted_16 = { class: "text" }
const _hoisted_17 = { class: "list" }
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "list" }
const _hoisted_20 = { class: "text" }
const _hoisted_21 = { class: "list" }
const _hoisted_22 = { class: "text" }
const _hoisted_23 = { class: "list" }
const _hoisted_24 = { class: "text" }
const _hoisted_25 = { class: "list" }
const _hoisted_26 = { class: "text" }
const _hoisted_27 = { class: "list" }
const _hoisted_28 = { class: "text" }
const _hoisted_29 = { class: "list" }
const _hoisted_30 = { class: "text" }
const _hoisted_31 = { class: "list" }
const _hoisted_32 = { class: "text" }
const _hoisted_33 = { class: "list" }
const _hoisted_34 = { class: "text" }
const _hoisted_35 = { class: "list" }
const _hoisted_36 = { class: "text" }
const _hoisted_37 = { class: "list" }
const _hoisted_38 = { class: "text" }
const _hoisted_39 = { class: "list" }
const _hoisted_40 = { class: "text" }
const _hoisted_41 = { class: "list" }
const _hoisted_42 = { class: "text" }
const _hoisted_43 = { class: "list" }
const _hoisted_44 = { class: "text" }
const _hoisted_45 = { class: "list" }
const _hoisted_46 = { class: "text" }
const _hoisted_47 = { class: "list" }
const _hoisted_48 = { class: "text" }
const _hoisted_49 = { class: "list" }
const _hoisted_50 = { class: "text" }
const _hoisted_51 = { class: "list" }
const _hoisted_52 = { class: "text" }
const _hoisted_53 = { class: "list" }
const _hoisted_54 = { class: "text" }
const _hoisted_55 = { class: "list" }
const _hoisted_56 = { class: "text" }
const _hoisted_57 = { class: "list" }
const _hoisted_58 = { class: "text" }
const _hoisted_59 = { class: "list" }
const _hoisted_60 = { class: "text" }
const _hoisted_61 = { class: "list" }
const _hoisted_62 = { class: "text" }
const _hoisted_63 = { class: "list" }
const _hoisted_64 = { class: "text" }
const _hoisted_65 = { class: "list" }
const _hoisted_66 = { class: "text" }
const _hoisted_67 = { class: "list" }
const _hoisted_68 = { class: "text" }
const _hoisted_69 = { class: "list" }
const _hoisted_70 = { class: "text" }
const _hoisted_71 = { class: "list" }
const _hoisted_72 = { class: "text" }
const _hoisted_73 = { class: "list" }
const _hoisted_74 = { class: "text" }
const _hoisted_75 = { class: "list" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "机械原理动画", -1))
const _hoisted_77 = { class: "second" }
const _hoisted_78 = { class: "onemenu2" }
const _hoisted_79 = { class: "text" }
const _hoisted_80 = { class: "list" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "自动化知识学习区", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "one-img",
  src: "https://image.sjyuan.net.cn/img/sjy/share/indextz.png"
}, null, -1))
const _hoisted_83 = { class: "second" }
const _hoisted_84 = { class: "onemenu3" }
const _hoisted_85 = { class: "text" }
const _hoisted_86 = { class: "list" }
const _hoisted_87 = { class: "text" }
const _hoisted_88 = { class: "list" }
const _hoisted_89 = { class: "text" }
const _hoisted_90 = { class: "list" }
const _hoisted_91 = { class: "text" }
const _hoisted_92 = { class: "list" }
const _hoisted_93 = { class: "text" }
const _hoisted_94 = { class: "list" }
const _hoisted_95 = { class: "text" }
const _hoisted_96 = { class: "list" }
const _hoisted_97 = { class: "text" }
const _hoisted_98 = { class: "list" }
const _hoisted_99 = { class: "text" }
const _hoisted_100 = { class: "list" }
const _hoisted_101 = { class: "text" }
const _hoisted_102 = { class: "list" }
const _hoisted_103 = { class: "text" }
const _hoisted_104 = { class: "list" }
const _hoisted_105 = { class: "text" }
const _hoisted_106 = { class: "list" }
const _hoisted_107 = { class: "text" }
const _hoisted_108 = { class: "list" }
const _hoisted_109 = { class: "text" }
const _hoisted_110 = { class: "list" }
const _hoisted_111 = { class: "text" }
const _hoisted_112 = { class: "list" }
const _hoisted_113 = { class: "text" }
const _hoisted_114 = { class: "list" }
const _hoisted_115 = { class: "text" }
const _hoisted_116 = { class: "list" }
const _hoisted_117 = { class: "text" }
const _hoisted_118 = { class: "list" }
const _hoisted_119 = { class: "text" }
const _hoisted_120 = { class: "list" }
const _hoisted_121 = { class: "text" }
const _hoisted_122 = { class: "list" }
const _hoisted_123 = { class: "text" }
const _hoisted_124 = { class: "list" }
const _hoisted_125 = { class: "text" }
const _hoisted_126 = { class: "list" }
const _hoisted_127 = { class: "text" }
const _hoisted_128 = { class: "list" }
const _hoisted_129 = { class: "text" }
const _hoisted_130 = { class: "list" }
const _hoisted_131 = { class: "text" }
const _hoisted_132 = { class: "list" }
const _hoisted_133 = { class: "text" }
const _hoisted_134 = { class: "list" }
const _hoisted_135 = { class: "text" }
const _hoisted_136 = { class: "list" }
const _hoisted_137 = { class: "text" }
const _hoisted_138 = { class: "list" }
const _hoisted_139 = { class: "four" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "减速机", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电动机和控制器", -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "工业机器人", -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "气动和液压", -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "控制系统", -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "机器视觉系统", -1))
const _hoisted_146 = [
  _hoisted_140,
  _hoisted_141,
  _hoisted_142,
  _hoisted_143,
  _hoisted_144,
  _hoisted_145
]
const _hoisted_147 = { class: "onemenu4" }
const _hoisted_148 = { class: "text" }
const _hoisted_149 = ["onClick"]
const _hoisted_150 = { class: "list" }
const _hoisted_151 = ["onClick"]
const _hoisted_152 = {
  key: 0,
  class: "right"
}
const _hoisted_153 = { class: "one" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "welcome" }, "Hi, 欢迎来到设纪元", -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login" }, "登录", -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "register" }, "注册", -1))
const _hoisted_158 = { class: "list" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "我的订单")
], -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "作品管理")
], -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "我的账户")
], -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "我的收藏")
], -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "我的足迹")
], -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "使用指南")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_carousel, {
            interval: 5000,
            onChange: _ctx.changeClass,
            arrow: "never"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item) => {
                return _createVNode(_component_el_carousel_item, {
                  key: item,
                  style: {"height":"517px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]),
            _: 1
          }, 8, ["onChange"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.classList && _ctx.classList['自动化设计方案'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["one", { 'one-active': _ctx.state == 0 }])
            }, [
              _createVNode(_component_router_link, { to: {
							name: 'goods-class',
						} }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _hoisted_7
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", null, [
                  _createVNode(_component_router_link, {
                    to: {
									name: 'goods-class',
									params: {
										classid: _ctx.classList.自动化设计方案[0].id,
									},
								}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.classList.自动化设计方案[0].names), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_router_link, {
                    to: {
									name: 'goods-class',
									params: {
										classid: _ctx.classList.自动化设计方案[1].id,
									},
								}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.classList.自动化设计方案[1].names), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_router_link, {
                    to: {
									name: 'goods-class',
									params: {
										classid: _ctx.classList.自动化设计方案[2].id,
									},
								}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.classList.自动化设计方案[2].names), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_router_link, {
                    to: {
									name: 'goods-class',
									params: {
										classid: _ctx.classList.自动化设计方案[3].id,
									},
								}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.classList.自动化设计方案[3].names), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_router_link, {
                    to: {
									name: 'goods-class',
									params: {
										classid: _ctx.classList.自动化设计方案[4].id,
									},
								}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.classList.自动化设计方案[4].names), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_router_link, {
                    to: {
									name: 'goods-class',
									params: {
										classid: _ctx.classList.自动化设计方案[5].id,
									},
								}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.classList.自动化设计方案[5].names), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.tabPosition,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabPosition) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_tabs, {
                  "tab-position": _ctx.tabPosition,
                  style: {"height":"488px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.自动化设计方案[0].names,
                      class: "title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[0].son[0].names), 1),
                            _createElementVNode("div", _hoisted_11, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[0].son[0].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'goods-class',
															params: {
																classid: _ctx.classList.自动化设计方案[0].id,
																attrid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.names), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[0].son[1].names), 1),
                            _createElementVNode("div", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[0].son[1].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'goods-class',
															params: {
																classid: _ctx.classList.自动化设计方案[0].id,
																attrid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.names), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[0].son[2].names), 1),
                            _createElementVNode("div", _hoisted_15, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[0].son[2].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'goods-class',
															params: {
																classid: _ctx.classList.自动化设计方案[0].id,
																attrid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.names), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[0].son[3].names), 1),
                            _createElementVNode("div", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[0].son[3].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'goods-class',
															params: {
																classid: _ctx.classList.自动化设计方案[0].id,
																attrid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.names), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[0].son[4].names), 1),
                            _createElementVNode("div", _hoisted_19, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[0].son[4].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'goods-class',
															params: {
																classid: _ctx.classList.自动化设计方案[0].id,
																attrid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.names), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.自动化设计方案[1].names,
                      class: "title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[1].son[0].names), 1),
                            _createElementVNode("div", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[1].son[0].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'goods-class',
															params: {
																classid: _ctx.classList.自动化设计方案[1].id,
																attrid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.names), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[1].son[1].names), 1),
                            _createElementVNode("div", _hoisted_23, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[1].son[1].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'goods-class',
															params: {
																classid: _ctx.classList.自动化设计方案[1].id,
																attrid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.names), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[1].son[2].names), 1),
                            _createElementVNode("div", _hoisted_25, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[1].son[2].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'goods-class',
															params: {
																classid: _ctx.classList.自动化设计方案[1].id,
																attrid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.names), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[1].son[3].names), 1),
                            _createElementVNode("div", _hoisted_27, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[1].son[3].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'goods-class',
															params: {
																classid: _ctx.classList.自动化设计方案[1].id,
																attrid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.names), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[1].son[4].names), 1),
                            _createElementVNode("div", _hoisted_29, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[1].son[4].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'goods-class',
															params: {
																classid: _ctx.classList.自动化设计方案[1].id,
																attrid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.names), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.自动化设计方案[2].names
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[2].son[0].names), 1),
                          _createElementVNode("div", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[2].son[0].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[2].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[2].son[1].names), 1),
                          _createElementVNode("div", _hoisted_33, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[2].son[1].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[2].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[2].son[2].names), 1),
                          _createElementVNode("div", _hoisted_35, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[2].son[2].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[2].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[2].son[3].names), 1),
                          _createElementVNode("div", _hoisted_37, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[2].son[3].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[2].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[2].son[4].names), 1),
                          _createElementVNode("div", _hoisted_39, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[2].son[4].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[2].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.自动化设计方案[3].names,
                      class: "title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[3].son[0].names), 1),
                          _createElementVNode("div", _hoisted_41, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[3].son[0].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[3].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[3].son[1].names), 1),
                          _createElementVNode("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[3].son[1].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[3].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[3].son[2].names), 1),
                          _createElementVNode("div", _hoisted_45, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[3].son[2].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[3].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[3].son[3].names), 1),
                          _createElementVNode("div", _hoisted_47, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[3].son[3].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[3].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[3].son[4].names), 1),
                          _createElementVNode("div", _hoisted_49, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[3].son[4].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[3].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[3].son[5].names), 1),
                          _createElementVNode("div", _hoisted_51, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[3].son[5].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[3].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.自动化设计方案[4].names,
                      class: "title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[4].son[0].names), 1),
                          _createElementVNode("div", _hoisted_53, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[4].son[0].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[4].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[4].son[1].names), 1),
                          _createElementVNode("div", _hoisted_55, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[4].son[1].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[4].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[4].son[2].names), 1),
                          _createElementVNode("div", _hoisted_57, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[4].son[2].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[4].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[4].son[3].names), 1),
                          _createElementVNode("div", _hoisted_59, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[4].son[3].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[4].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[4].son[4].names), 1),
                          _createElementVNode("div", _hoisted_61, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[4].son[4].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[4].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[4].son[5].names), 1),
                          _createElementVNode("div", _hoisted_63, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[4].son[5].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[4].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.自动化设计方案[5].names,
                      class: "title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[5].son[0].names), 1),
                          _createElementVNode("div", _hoisted_65, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[5].son[0].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[5].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[5].son[1].names), 1),
                          _createElementVNode("div", _hoisted_67, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[5].son[1].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[5].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[5].son[2].names), 1),
                          _createElementVNode("div", _hoisted_69, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[5].son[2].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[5].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[5].son[3].names), 1),
                          _createElementVNode("div", _hoisted_71, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[5].son[3].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[5].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[5].son[4].names), 1),
                          _createElementVNode("div", _hoisted_73, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[5].son[4].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[5].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.自动化设计方案[5].son[5].names), 1),
                          _createElementVNode("div", _hoisted_75, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.自动化设计方案[5].son[5].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'goods-class',
														params: {
															classid: _ctx.classList.自动化设计方案[5].id,
															attrid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.names), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["tab-position"])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([{ 'one-active': _ctx.state == 1 }, "two"])
            }, [
              _createVNode(_component_router_link, { to: {
							name: 'video',
						} }, {
                default: _withCtx(() => [
                  _hoisted_76
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_77, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.机械原理动画, (item, index) => {
                  return (_openBlock(), _createElementBlock("p", null, [
                    _createVNode(_component_router_link, {
                      to: {
									name: 'video',
									params: {
										id: index + 1,
									},
								}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 256))
              ]),
              _createElementVNode("div", _hoisted_78, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.tabPosition,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tabPosition) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_tabs, {
                  "tab-position": _ctx.tabPosition,
                  style: {"height":"488px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.机械原理动画, (classitem, index) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_79, [
                        _createElementVNode("h2", null, _toDisplayString(classitem.name), 1),
                        _createElementVNode("div", _hoisted_80, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classitem.son, (item) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: item.id
                            }, [
                              _createVNode(_component_router_link, {
                                to: {
													name: 'video-class',
													params: {
														cid: classitem.cid,
														aid: item.aid,
													},
												}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["tab-position"])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["three", { 'one-active': _ctx.state == 2 }])
            }, [
              _createVNode(_component_router_link, { to: {
							name: 'free',
						} }, {
                default: _withCtx(() => [
                  _hoisted_81,
                  _hoisted_82
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_83, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区, (item, index) => {
                  return (_openBlock(), _createElementBlock("p", null, [
                    _createVNode(_component_router_link, {
                      to: {
										name: 'free',
										params: {
											cid: item.id,
										},
									}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 256))
              ]),
              _createElementVNode("div", _hoisted_84, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.tabPosition,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tabPosition) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_tabs, {
                  "tab-position": _ctx.tabPosition,
                  style: {"height":"488px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.免费专区[0].name,
                      class: "title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[0].son[0].name), 1),
                            _createElementVNode("div", _hoisted_86, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[0].son[0].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[0].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[0].son[1].name), 1),
                            _createElementVNode("div", _hoisted_88, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[0].son[1].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[0].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[0].son[2].name), 1),
                            _createElementVNode("div", _hoisted_90, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[0].son[2].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[0].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[0].son[3].name), 1),
                            _createElementVNode("div", _hoisted_92, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[0].son[3].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[0].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.免费专区[1].name,
                      class: "title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[1].son[0].name), 1),
                            _createElementVNode("div", _hoisted_94, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[1].son[0].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[1].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_95, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[1].son[1].name), 1),
                            _createElementVNode("div", _hoisted_96, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[1].son[1].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[1].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_97, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[1].son[2].name), 1),
                            _createElementVNode("div", _hoisted_98, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[1].son[2].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[1].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[1].son[3].name), 1),
                            _createElementVNode("div", _hoisted_100, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[1].son[3].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[1].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[1].son[4].name), 1),
                            _createElementVNode("div", _hoisted_102, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[1].son[4].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[1].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.免费专区[2].name,
                      class: "title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_103, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[2].son[0].name), 1),
                            _createElementVNode("div", _hoisted_104, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[2].son[0].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[2].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_105, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[2].son[1].name), 1),
                            _createElementVNode("div", _hoisted_106, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[2].son[1].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[2].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_107, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[2].son[2].name), 1),
                            _createElementVNode("div", _hoisted_108, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[2].son[2].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[2].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_109, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[2].son[3].name), 1),
                            _createElementVNode("div", _hoisted_110, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[2].son[3].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[2].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.免费专区[3].name,
                      class: "title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_111, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[3].son[0].name), 1),
                            _createElementVNode("div", _hoisted_112, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[3].son[0].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[3].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_113, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[3].son[1].name), 1),
                            _createElementVNode("div", _hoisted_114, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[3].son[1].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[3].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_115, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[3].son[2].name), 1),
                            _createElementVNode("div", _hoisted_116, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[3].son[2].son1, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
															name: 'free',
															params: {
																cid: _ctx.classList.免费专区[3].id,
																aid: item.id,
															},
														}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.免费专区[4].name,
                      class: "title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_117, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[4].son[0].name), 1),
                          _createElementVNode("div", _hoisted_118, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[4].son[0].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'free',
														params: {
															cid: _ctx.classList.免费专区[4].id,
															aid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_119, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[4].son[1].name), 1),
                          _createElementVNode("div", _hoisted_120, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[4].son[1].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'free',
														params: {
															cid: _ctx.classList.免费专区[4].id,
															aid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_121, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[4].son[2].name), 1),
                          _createElementVNode("div", _hoisted_122, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[4].son[2].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'free',
														params: {
															cid: _ctx.classList.免费专区[4].id,
															aid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.免费专区[5].name,
                      class: "title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_123, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[5].son[0].name), 1),
                          _createElementVNode("div", _hoisted_124, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[5].son[0].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'free',
														params: {
															cid: _ctx.classList.免费专区[5].id,
															aid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_125, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[5].son[1].name), 1),
                          _createElementVNode("div", _hoisted_126, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[5].son[1].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'free',
														params: {
															cid: _ctx.classList.免费专区[5].id,
															aid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_127, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[5].son[2].name), 1),
                          _createElementVNode("div", _hoisted_128, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[5].son[2].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'free',
														params: {
															cid: _ctx.classList.免费专区[5].id,
															aid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_129, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[5].son[3].name), 1),
                          _createElementVNode("div", _hoisted_130, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[5].son[3].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'free',
														params: {
															cid: _ctx.classList.免费专区[5].id,
															aid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_tab_pane, {
                      label: _ctx.classList.免费专区[6].name,
                      class: "title"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_131, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[6].son[0].name), 1),
                          _createElementVNode("div", _hoisted_132, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[6].son[0].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'free',
														params: {
															cid: _ctx.classList.免费专区[6].id,
															aid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_133, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[6].son[1].name), 1),
                          _createElementVNode("div", _hoisted_134, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[6].son[1].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'free',
														params: {
															cid: _ctx.classList.免费专区[6].id,
															aid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[6].son[2].name), 1),
                          _createElementVNode("div", _hoisted_136, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[6].son[2].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'free',
														params: {
															cid: _ctx.classList.免费专区[6].id,
															aid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_137, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.classList.免费专区[6].son[3].name), 1),
                          _createElementVNode("div", _hoisted_138, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classList.免费专区[6].son[3].son1, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: {
														name: 'free',
														params: {
															cid: _ctx.classList.免费专区[6].id,
															aid: item.id,
														},
													}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["tab-position"])
              ])
            ], 2),
            _createElementVNode("div", _hoisted_139, [
              _createElementVNode("h3", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gotoMovibot('')))
              }, "工业自动化设备供应链"),
              _createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotoMovibot(''))),
                class: "second"
              }, _hoisted_146),
              _createElementVNode("div", _hoisted_147, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.tabPosition,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tabPosition) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_tabs, {
                  "tab-position": _ctx.tabPosition,
                  style: {"height":"488px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movibotClass[0].list, (movibot, index) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_148, [
                        _createElementVNode("h2", {
                          onClick: ($event: any) => (_ctx.gotoMovibot(movibot.url))
                        }, _toDisplayString(movibot.name), 9, _hoisted_149),
                        _createElementVNode("div", _hoisted_150, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(movibot.list, (item) => {
                            return (_openBlock(), _createElementBlock("p", {
                              onClick: ($event: any) => (_ctx.gotoMovibot(item.url))
                            }, _toDisplayString(item.name), 9, _hoisted_151))
                          }), 256))
                        ])
                      ]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["tab-position"])
              ])
            ])
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                _createElementVNode("div", _hoisted_153, [
                  _hoisted_154,
                  _hoisted_155,
                  _createVNode(_component_router_link, { to: "/login" }, {
                    default: _withCtx(() => [
                      _hoisted_156
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/register" }, {
                    default: _withCtx(() => [
                      _hoisted_157
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_158, [
                  _createVNode(_component_router_link, { to: "/user/myorder" }, {
                    default: _withCtx(() => [
                      _hoisted_159
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user/works" }, {
                    default: _withCtx(() => [
                      _hoisted_160
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user/myaccount" }, {
                    default: _withCtx(() => [
                      _hoisted_161
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user/project" }, {
                    default: _withCtx(() => [
                      _hoisted_162
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user/myfootmark" }, {
                    default: _withCtx(() => [
                      _hoisted_163
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user" }, {
                    default: _withCtx(() => [
                      _hoisted_164
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}